// File: src/components/car/QualityReportModal.jsx
// FIX: Restructured to flex-column so buttons stay fixed at bottom while content scrolls
import React, { useState } from 'react';
import './QualityReportModal.css';

const QualityReportModal = ({ isOpen, onClose, car, onBookNow, onTestDrive }) => {
  const [activeTab, setActiveTab] = useState('core_systems');

  if (!isOpen) return null;

  const qualityReport = car?.quality_report;
  const inspectionSummary = car?.inspection_items_summary || {};
  const inspectionImages = car?.inspection_images_urls || [];

  if (!qualityReport) return null;

  const getScoreColor = (score) => {
    if (score >= 9)   return '#10b981';
    if (score >= 7.5) return '#f59e0b';
    return '#ef4444';
  };

  const getScoreLabel = (score) => {
    if (score >= 9)   return 'Excellent';
    if (score >= 7.5) return 'Good';
    return 'Fair';
  };

  const tabs = [
    { id: 'core_systems',       label: 'Core systems',       icon: '⚙️', score: qualityReport.core_systems_score,       category: 'Core systems' },
    { id: 'supporting_systems', label: 'Supporting systems', icon: '🔌', score: qualityReport.supporting_systems_score, category: 'Supporting systems' },
    { id: 'interiors_ac',       label: 'Interiors & AC',     icon: '🪑', score: qualityReport.interiors_ac_score,       category: 'Interiors & AC' },
    { id: 'exteriors_lights',   label: 'Exteriors & lights', icon: '💡', score: qualityReport.exteriors_lights_score,   category: 'Exteriors & lights' },
    { id: 'wear_tear',          label: 'Wear & tear parts',  icon: '🔧', score: qualityReport.wear_tear_score,          category: 'Wear & tear parts' },
  ];

  const activeTabData   = tabs.find(t => t.id === activeTab);
  const categoryItems   = inspectionSummary[activeTabData?.category] || {};

  const handleBookNowClick = () => { onClose(); onBookNow?.(); };
  const handleTestDriveClick = () => { onClose(); onTestDrive?.(); };

  return (
    <div className="qrm-overlay" onClick={onClose}>
      {/* ✅ FIX: flex-col container — overflow: hidden (clips), not auto */}
      <div className="qrm-container" onClick={e => e.stopPropagation()}>

        {/* ── Fixed Header ── */}
        <div className="qrm-header">
          <button className="qrm-back-btn" onClick={onClose}>
            ← Car quality report
          </button>
        </div>

        {/* ── Scrollable Body ── */}
        <div className="qrm-body">

          {/* Car Info */}
          <div className="qrm-car-info">
            <h2>{car.year} {car.brand} {car.model}</h2>
            <p>{car.km_driven || car.mileage} Km · {car.fuel_type} · {car.transmission}</p>
          </div>

          {/* Highlights */}
          <div className="qrm-highlights">
            <h3>HIGHLIGHTS</h3>
            <div className="qrm-highlights-grid">
              <div className="qrm-highlight-item">
                <span className="qrm-highlight-icon">🚗</span>
                <div>
                  <strong>Less driven per year</strong>
                  <p>Usage lower than 8,000 km per year</p>
                </div>
              </div>
              <div className="qrm-highlight-item">
                <span className="qrm-highlight-icon">🎵</span>
                <div><strong>Integrated in-dash music system</strong></div>
              </div>
              <div className="qrm-highlight-item">
                <span className="qrm-highlight-icon">🔙</span>
                <div><strong>Equipped with rear defogger</strong></div>
              </div>
              <div className="qrm-highlight-item">
                <span className="qrm-highlight-icon">🅿️</span>
                <div><strong>Equipped with rear parking sensors</strong></div>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="qrm-tabs">
            {tabs.map(tab => (
              <button
                key={tab.id}
                className={`qrm-tab-btn${activeTab === tab.id ? ' qrm-tab-btn--active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                <div className="qrm-tab-left">
                  <span className="qrm-tab-icon">{tab.icon}</span>
                  <span className="qrm-tab-label">{tab.label}</span>
                </div>
                <div className="qrm-tab-right">
                  <span className="qrm-tab-score" style={{ background: getScoreColor(tab.score) }}>
                    {tab.score}
                  </span>
                  <span className="qrm-tab-score-label">{getScoreLabel(tab.score)}</span>
                </div>
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="qrm-tab-content">
            <div className="qrm-score-header">
              <span className="qrm-score-icon">{activeTabData?.icon}</span>
              <div>
                <h3>{activeTabData?.label}</h3>
                <p>{categoryItems?.total || 0} parts across {Object.keys(categoryItems?.items || {}).length} assemblies</p>
              </div>
            </div>

            {categoryItems?.items && Object.keys(categoryItems.items).length > 0 ? (
              <div className="qrm-inspection-items">
                {Object.entries(categoryItems.items).map(([itemName, itemData], index) => (
                  <div key={index} className="qrm-inspection-item">
                    <div className="qrm-item-header">
                      <span className={`qrm-item-status${itemData.status === 'ok' ? ' qrm-item-status--ok' : ' qrm-item-status--notok'}`}>
                        {itemData.status === 'ok' ? '✓' : '○'}
                      </span>
                      <span className="qrm-item-name">{itemName}</span>
                    </div>
                    {itemData.remarks && <p className="qrm-item-remarks">{itemData.remarks}</p>}
                  </div>
                ))}
              </div>
            ) : (
              <div className="qrm-no-items"><p>All parts in excellent condition</p></div>
            )}

            {activeTab === 'interiors_ac' && (
              <div className="qrm-brand-new">
                <span className="qrm-brand-new-badge">✨ BRAND NEW</span>
                <p>Wiper +3 more</p>
              </div>
            )}
            {activeTab === 'exteriors_lights' && (
              <div className="qrm-customized">
                <span className="qrm-customized-badge">CUSTOMISED PARTS</span>
                <div className="qrm-customized-items"><span>+ ORVM housing</span></div>
              </div>
            )}
            {activeTab === 'wear_tear' && (
              <div className="qrm-service-info">
                <span>ℹ️</span>
                <p>Next service due after 12 months or 10,000 km (whichever comes first post delivery)</p>
              </div>
            )}
          </div>

          {/* Inspection Images */}
          {inspectionImages.length > 0 && (
            <div className="qrm-images-section">
              <h3>Inspection Images</h3>
              <div className="qrm-images-grid">
                {inspectionImages.map((img, index) => (
                  <img key={index} src={`http://localhost:3001${img}`} alt={`Inspection ${index + 1}`} className="qrm-inspection-image" />
                ))}
              </div>
            </div>
          )}

          {/* Footer note */}
          <div className="qrm-footer">
            <p className="qrm-expert-note">
              Our team has carefully reviewed and approved this car's quality
            </p>
          </div>

        </div>{/* end qrm-body */}

        {/* ── Fixed Bottom Actions — outside scrollable body ── */}
        <div className="qrm-actions">
          <button className="qrm-action-btn qrm-book-btn" onClick={handleBookNowClick}>
            BOOK NOW
            <small>100% refundable</small>
          </button>
          <button className="qrm-action-btn qrm-test-drive-btn" onClick={handleTestDriveClick}>
            FREE TEST DRIVE
          </button>
        </div>

      </div>{/* end qrm-container */}
    </div>
  );
};

export default QualityReportModal;